import { Box, Container, Grid, Typography } from "@mui/material";
import React from "react";
import { useParams } from "react-router-dom";
import LoadingPage from "../components/LoadingScreen";
import { useGetSingleCryptoQuery } from "../services/cryptoApi";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import millify from "millify";
import { useDispatch } from "react-redux";
import { loadingActions } from "../store/loading-slice";

const CryptoDetail = () => {
  const params = useParams();
  const { cryptoTicker } = params;
  const { data, isLoading, isError, isSuccess } =
    useGetSingleCryptoQuery(cryptoTicker);
  const dispatch = useDispatch();

  if (isLoading) {
    dispatch(loadingActions.openHandler())
    return <LoadingPage />;
  }

  if (isError) {
    return <p>Error</p>;
  }

  if (isSuccess) {
    dispatch(loadingActions.closeHandler());
  }

  if (data) {
    console.log(data);
  }

  console.log(params);
  return (
    <Grid container direction="column">
      <Typography variant="h5" sx={{ fontWeight: 500, mt: 2 }} align="center">
        Previous Close
      </Typography>
      <Typography variant="h5" sx={{ fontWeight: 500, mt: 2 }} align="center">
        {data?.results[0]?.T.replace("X:", "")}
      </Typography>
      <Container maxWidth="md" sx={{ mt: 2 }}>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography>T</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              The exchange symbol that this item is traded under.
            </Typography>
            <br />
            <Box sx={{ fontWeight: 600 }}> T: {data?.results[0]?.T}</Box>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
            <Typography>v</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              The trading volume of the symbol in the given time period.
            </Typography>
            <br />
            <Box sx={{ fontWeight: 600 }}>
              {" "}
              v: {millify(data?.results[0]?.v)}
            </Box>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3a-content"
            id="panel3a-header"
          >
            <Typography>vw</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              The trading volume of the symbol in the given time period.
            </Typography>
            <br />
            <Box sx={{ fontWeight: 600 }}>
              {" "}
              vw: {millify(data?.results[0]?.vw)}
            </Box>
          </AccordionDetails>
        </Accordion>
      </Container>
    </Grid>
  );
};

export default CryptoDetail;
